export const rolePath = [
    {role:"SUPER_ADMIN",path:"/users"},
    {role:"ADMIN_BO",path:"/users"},
    {role:"OPERATOR_BO",path:"/users"},
];

export const privileges = {
    editingUsers: ["SUPER_ADMIN","ADMIN_BO"],
    editingUserTags: ["SUPER_ADMIN","ADMIN_BO"],
    editingDoors: ["SUPER_ADMIN","ADMIN_BO"],
    editingDoorTags: ["SUPER_ADMIN","ADMIN_BO"],
    logs: ["SUPER_ADMIN","ADMIN_BO","OPERATOR_BO"],
    applicationLogs:["SUPER_ADMIN"]

}